module.exports = __webpack_public_path__ + "static/media/Quokka_Banner_V2.d3e9dd13.svg";